const TRANSLATION_DEBUG_STORAGE_KEY = 'fu-devtools-translations'

type TranslationDebugSettings = {
  showKeys: boolean
  showLocalazyLinks: boolean
  checkVariables: boolean
}

const defaultSettings: TranslationDebugSettings = {
  showKeys: false,
  showLocalazyLinks: false,
  checkVariables: false,
}

const loadSettings = (): TranslationDebugSettings => {
  try {
    const stored = window.localStorage.getItem(TRANSLATION_DEBUG_STORAGE_KEY)
    if (stored) {
      return { ...defaultSettings, ...JSON.parse(stored) }
    }
  } catch {
    /* localStorage may not be available */
  }
  return defaultSettings
}

// Module-level state — loaded once on import, before React render
const settings: TranslationDebugSettings = loadSettings()

const getTranslationDebugSettings = (): TranslationDebugSettings => settings

const LOCALAZY_SEARCH_URL = 'https://localazy.com/p/monorepo/source-language?search='

export { TRANSLATION_DEBUG_STORAGE_KEY, LOCALAZY_SEARCH_URL, getTranslationDebugSettings }
export type { TranslationDebugSettings }
